import { createFileRoute } from "@tanstack/react-router";
import { PendingSurface } from "@/components/feedback/pending-surface";

export const Route = createFileRoute("/_authenticated/")({
  component: () => <PendingSurface titleKey="nav.home" />,
});
